import { Box } from "@mui/material";

export const FullWidthSection = ({
  backgroundColor,
  backgroundImage,
  backgroundSize = "cover",
  backgroundPosition = "center",
  backgroundRepeat = "no-repeat",
  borderRadiusTop,
  borderRadiusTopRight,
  borderRadiusBottom,
  borderRadiusBottomRight,
  borderRadius,
  backgroundDisplay = {
    xs: "none",
    sm: "none",
    md: "block",
    lg: "block",
    xl: "block",
  },
  children,
  sx = {},
  ...props
}) => {
  const calculateBorderRadius = () => {
    return {
      borderTopRightRadius:
        borderRadiusTopRight || borderRadiusTop || borderRadius || 0,
      borderBottomRightRadius:
        borderRadiusBottomRight || borderRadiusBottom || borderRadius || 0,
    };
  };

  const applyResponsiveDisplay = (bgImage) => {
    return {
      xs: backgroundDisplay.xs === "block" ? bgImage : "none",
      sm: backgroundDisplay.sm === "block" ? bgImage : "none",
      md: backgroundDisplay.md === "block" ? bgImage : "none",
      lg: backgroundDisplay.lg === "block" ? bgImage : "none",
      xl: backgroundDisplay.xl === "block" ? bgImage : "none",
    };
  };
  // Separate sx overrides that need responsive display treatment
  const sxBackgroundImage = sx.backgroundImage;
  const restSx = { ...sx };
  delete restSx.backgroundImage;

  return (
    <Box
      sx={{
        backgroundColor: backgroundColor,
        ...(backgroundImage && {
          backgroundImage: applyResponsiveDisplay(`url(${backgroundImage})`),
        }),
        ...(sxBackgroundImage && {
          backgroundImage: applyResponsiveDisplay(sxBackgroundImage),
        }),
        backgroundSize,
        backgroundPosition,
        backgroundRepeat,
        minHeight:
          backgroundImage || sxBackgroundImage
            ? { xs: "auto", md: "600px", lg: "700px", xl: "800px" }
            : "auto",
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)", // Using negative margin to break out of parent container
        marginRight: "calc(-50vw + 50%)",
        boxSizing: "border-box",
        ...calculateBorderRadius(),
        ...restSx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
